import { Configurer } from '../Core/index';
import { Queue } from './Queue';
import { ConfigurableHttpOutput, StringAnyMap } from '../CommonTypes';

/**Producer consumer service. Users can submit tasks and other users consume them*/
export class QueueConfigurer extends Configurer {
  /**
   * HTTP entry point to run tasks.
   *
   * Your tasks can be submitted via HTTP.
   * */
}
